export default __webpack_public_path__ + "static/media/_table-sort-ascend-icon.13100612.svg";